import { render, staticRenderFns } from "./SubmitSuccessModal.vue?vue&type=template&id=1b359fe3&scoped=true"
import script from "./SubmitSuccessModal.vue?vue&type=script&lang=js"
export * from "./SubmitSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitSuccessModal.vue?vue&type=style&index=0&id=1b359fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b359fe3",
  null
  
)

export default component.exports